import { createSelector } from 'reselect';
import Encoder from './Encoder';
import mergeEncoding from '../utils/mergeEncoding';
export default function createEncoderFactory(params) {
  const {
    channelTypes
  } = params;
  const completeEncoding = 'defaultEncoding' in params ? encoding => mergeEncoding(params.defaultEncoding, encoding) : params.completeEncoding;

  const create = (encoding = {}) => new Encoder({
    channelTypes,
    encoding: completeEncoding(encoding)
  });

  return {
    channelTypes,
    create,
    createSelector: () => createSelector(encoding => encoding, create),
    DEFAULT_ENCODING: completeEncoding({})
  };
}